import ProductButton from "./ProductButton";
import StrengthButton from "./StrengthButton";
import QuantitySelector from "./QuantitySelector";
import DomFactory from "../Utils/DomFactory";
import BuyButton from "./BuyButton";
import ProductPageState from "./ProductPageState";
import * as Util from "../Utils/Util";
import { findByBindNameAll } from "../Utils/Util";
import PriceViewer from "./PriceViewer";
import ProductStateElementManager from "./ProductStateElementManager";
import PricingTableButton from "./PricingTableButton";
import PricingTable from "./PricingTable";
import { registerAnalytics } from "./Analytics";
import DiscountBubble from "./DiscountBubble";
import NewCustomerDiscountBubble from "./NewCustomerDiscountBubble";
import StrengthSelector from "./StrengthSelector";
import ProductSelector from "./ProductSelector";
import SubscriptionToggle from "./SubscriptionToggle";
import SubscriptionFrequencyButton from "./SubscriptionFrequencyButton";
import SubscriptionFrequencySelection from "./SubscriptionFrequencySelection";
import bindQuestionSections from "../Utils/QuestionSection";
import bindModals from "../Utils/SimpleModal";
import bindProductNameHolders from "./ProductNameHolder";
import bindProductQuantityHolders from "./ProductQuantityHolder";
import bindDiscountElementSwitchers from "./DiscountElementSwitcher";
import { bindProductPicker } from "@/ProductPage/components/ProductPicker/ProductPickerBinder";
import { bindProductReviewBlock } from "@/Reviews/ProductReviewBlockBinder";
import { loadPrices } from "../Utils/PriceLoader";
import Events from "../Utils/Events";

class PageBinder {
  private bindProductButtons(): void {
    this.createObjects("product-selection", ProductButton.Factory);
  }

  private bindProductSelectors(): void {
    this.createObjects("product-combo-selector", ProductSelector.Factory);
  }

  private bindStrengthButtons(): void {
    this.createObjects("strength-selection", StrengthButton.Factory);
  }

  private bindStrengthSelector(): void {
    this.createObjects("strength-selector", StrengthSelector.Factory);
  }

  private bindQuantitySelectors(): void {
    this.createObjects("quantity-selection", QuantitySelector.Factory);
  }

  private bindSubscriptionToggles(): void {
    this.createObjects("subscription-toggle", SubscriptionToggle.Factory);
    this.createObjects("subscription-frequency-button", SubscriptionFrequencyButton.Factory);
    this.createObjects("subscription-frequency-selection", SubscriptionFrequencySelection.Factory);
  }

  private bindBuyButtons(): void {
    this.createObjects("product-buy-button", BuyButton.Factory);
  }

  private bindPriceViewers(): any {
    return this.createObjects("price-viewer", PriceViewer.Factory);
  }
  private bindDiscountBubbles(): void {
    this.createObjects("discount-bubble", DiscountBubble.Factory);
    this.createObjects("discount-bubble-new-user", NewCustomerDiscountBubble.Factory);
  }

  private bindPricingTableButtons(): void {
    this.createObjects("pricing-table-strength-selection", PricingTableButton.Factory);
  }

  private bindDeliveryCountdown(): void {
    this.createObjects("delivery-countdown", PricingTableButton.Factory);
  }

  private bindPricingTables(): void {
    this.createObjects("product-pricing-table", PricingTable.Factory);
  }

  private createObjects<T>(domName: string, factory: DomFactory<T>): void {
    const elements = findByBindNameAll(domName);
    elements.forEach(factory);
  }

  private createShowHideBinders() {
    new ProductStateElementManager("product-bind", (s) => s.product.code);
  }

  public async bind(): Promise<void> {
    registerAnalytics();
    bindDiscountElementSwitchers();
    this.bindProductButtons();
    this.bindProductSelectors();
    this.bindStrengthButtons();
    this.bindStrengthSelector();
    this.bindQuantitySelectors();
    this.bindSubscriptionToggles();
    this.createShowHideBinders();
    this.bindBuyButtons();
    this.bindPriceViewers();
    this.bindDiscountBubbles();
    this.bindPricingTableButtons();
    this.bindPricingTables();
    this.bindDeliveryCountdown();

    bindQuestionSections();
    bindModals();
    bindProductNameHolders();
    bindProductQuantityHolders();

    let state;

    const category = Util.loadJSON("product-category");

    if (category === "ErectileDysfunction") {
      const prices = await loadPrices(category);
      state = ProductPageState.getInstanceWithPrices(prices);
    } else {
      state = ProductPageState.getInstance();
    }

    bindProductPicker(state.getProducts());
    bindProductReviewBlock(state.getProducts());

    state.publishStateChange();
    Events.fire("init-with-prices", {});
  }
}

(function setupReadyListener(): void {
  console.log("Hello world, product-page binder starting! ✅");
  const pageBinder = new PageBinder();
  document.addEventListener("DOMContentLoaded", () => pageBinder.bind());
})();
